import _ from 'lodash';
import moment from 'moment';
import ChoixPermis from './ChoixPermis/ChoixPermis';
import CrmAuto50Plus3Ans from './CrmAuto50Plus3Ans/CrmAuto50Plus3Ans';
import CrmMoto50Plus3Ans from './CrmMoto50Plus3Ans/CrmMoto50Plus3Ans';
import GoToAntecedents from './GoToAntecedents/GoToAntecedents';
import TitulaireCarteGrise from './TitulaireCarteGrise/TitulaireCarteGrise';
import {ValeurCrmAuto, ValeurCrmMoto, DateNaissance, DateNaissanceRepresentantLegal, DeclarationFormation, DeclarationAssurance} from '@amo/core/components/questions';
import {useEffect, useState} from "react";

const Profil = (props) => {
    const { data, id, dejaClientRefresh, changeValue, vehicule } = props;
    const dateNaissanceNew = _.get(data, 'DemandeTarif[ListePersonnes][0][DateNaissance]');
    const titulaireCarteGrise = _.get(data, 'titulaireCarteGrise');
    const [dateNaissanceValue, setDateNaissanceValue] = useState(_.get(data, 'DemandeTarif[ListePersonnes][0][DateNaissance]'));
    const [titulaireCarteGriseValue, setTitulaireCarteGriseValue] = useState(_.get(data, 'titulaireCarteGrise'));
    const datePermisB = moment(_.find(_.get(data, 'DemandeTarif[ListePersonnes][0][ListePermis]'), ['TypePermis', 'B'])?.DatePermis, 'DD/MM/YYYY')

    const isMineur = (date) =>
        moment(date, 'DD/MM/YYYY').add(18, 'years').isSameOrAfter(moment());

    useEffect(() => {
        if (moment(dateNaissanceNew, 'DD/MM/YYYY', true).isValid() && dateNaissanceNew !== dateNaissanceValue) {
            const wasMineur = isMineur(dateNaissanceValue);
            const isNowMineur = isMineur(dateNaissanceNew);

            if (wasMineur !== isNowMineur) {
                changeValue('titulaireCarteGrise', null); //Nécessaire car si on passe de majeur à souscripteur titulaireCarteGrise ne change pas donc pas de onchange
                setTitulaireCarteGriseValue(null);
            }
            setDateNaissanceValue(dateNaissanceNew);
            dejaClientRefresh({updateOnlyPersonFields: true});
        }
    }, [dateNaissanceNew]);

    useEffect(() => {
        if (titulaireCarteGrise && titulaireCarteGriseValue !== titulaireCarteGrise) {
            dejaClientRefresh({updateOnlyPersonFields: true});
            setTitulaireCarteGriseValue(titulaireCarteGrise);
        }
    }, [titulaireCarteGrise]);

    const hasOnlyPermisB = (permis) => {
        return !(_.find(permis, ['TypePermis', 'A1']) || _.find(permis, ['TypePermis', 'A']) || _.find(permis, ['TypePermis', 'A2'])) && _.find(permis, ['TypePermis', 'B']);
    };

    const permis = _.get(data, 'DemandeTarif[ListePersonnes][0][ListePermis]');
    const formation = _.get(data, 'DemandeTarif[ListePersonnes][0][Formation]');
    const declarationAssurance = _.get(data, 'DemandeTarif[ListePersonnes][0][DeclarationAssurance]');

    const formationVehiculePermisCondition =
        (_.includes(['moto', 'scooter', 'verte'], data?.typeVehicule) && Number(data?.cylindreeVehicule) > 50 && Number(data?.cylindreeVehicule) <= 125 && hasOnlyPermisB(permis)) ||
        (vehicule?.genre === 'TRI' && !_.find(permis, (p) => p?.TypePermis === 'A'));

    const showFormation = formationVehiculePermisCondition &&
        (datePermisB >= moment('2011-01-01') || (datePermisB >= moment('1980-03-01') && datePermisB < moment('2011-01-01')));

    const showDeclarationAssurance = formationVehiculePermisCondition &&
        datePermisB >= moment('1980-03-01') && datePermisB < moment('2011-01-01') && formation === '0';

    // Réinitialise la réponse à la formation 7h quand la question n'est plus affichée (ex: modification des permis)
    useEffect(() => {
        if (!showFormation && !_.isNil(formation)) {
            changeValue('DemandeTarif[ListePersonnes][0][Formation]', null);
        }
    }, [showFormation]);

    // Réinitialise la déclaration d'assurance quand la question n'est plus affichée
    useEffect(() => {
        if (!showDeclarationAssurance && !_.isNil(declarationAssurance)) {
            changeValue('DemandeTarif[ListePersonnes][0][DeclarationAssurance]', null);
        }
    }, [showDeclarationAssurance]);

    // Réinitialise les antécédents auto quand le permis B est absent, quelle que soit la façon
    // dont il a disparu (reprise déjà client, préremplissage, "je n'ai pas de permis"...)
    const hasPermisB = Boolean(_.find(permis, ['TypePermis', 'B']));
    useEffect(() => {
        if (!hasPermisB) {
            if (!_.isNil(_.get(data, 'DemandeTarif[ListePersonnes][0][ValeurCrmAuto]'))) {
                changeValue('DemandeTarif[ListePersonnes][0][ValeurCrmAuto]', null);
            }
            if (!_.isNil(_.get(data, 'DemandeTarif[ListePersonnes][0][NbMoisAssuranceAuto]'))) {
                changeValue('DemandeTarif[ListePersonnes][0][NbMoisAssuranceAuto]', null);
            }
            if (!_.isNil(_.get(data, 'DemandeTarif[ListePersonnes][0][CrmAuto50Plus3Ans]'))) {
                changeValue('DemandeTarif[ListePersonnes][0][CrmAuto50Plus3Ans]', null);
            }
        }
    }, [hasPermisB]);

    return (
        <div id={id}>
            <DateNaissance {...props} />

            {isMineur(dateNaissanceNew)&& <DateNaissanceRepresentantLegal {...props} />}

            <TitulaireCarteGrise {...props} />

            {moment(_.get(data, 'DemandeTarif[ListePersonnes][0][DateNaissance]'), 'DD/MM/YYYY').add(14, 'years') <
                moment() &&
                <>
                    <ChoixPermis {...props} />

                    {formationVehiculePermisCondition && (
                        <>
                            {showFormation && (
                                <DeclarationFormation {...props} datePermisB={datePermisB} />
                            )}
                            {showDeclarationAssurance && (
                                <DeclarationAssurance {...props} datePermisB={datePermisB} />
                            )}
                        </>
                    )}

                </>
            }

            {!_.includes(['quad', 'verte', '50'], data?.typeVehicule) &&
                _.find(_.get(data, 'DemandeTarif[ListePersonnes][0][ListePermis]'), (permis) => {
                    return _.includes(['AM', 'A1', 'A2', 'A', 'B'], permis?.TypePermis);
                }) && <ValeurCrmMoto {...props} />}

            {Number(_.get(data, 'DemandeTarif[ListePersonnes][0][ValeurCrmMoto]')) === 0.5 && (
                <CrmMoto50Plus3Ans {...props} />
            )}

            {!_.includes(['quad', 'verte', '50'], data?.typeVehicule) &&
                _.find(_.get(data, 'DemandeTarif[ListePersonnes][0][ListePermis]'), (permis) => {
                    return _.includes(['B'], permis?.TypePermis);
                }) && <ValeurCrmAuto {...props} />}

            {Number(_.get(data, 'DemandeTarif[ListePersonnes][0][ValeurCrmAuto]')) === 0.5 && (
                <CrmAuto50Plus3Ans {...props} />
            )}

            <GoToAntecedents {...props} />
        </div>
    );
};

export default Profil;
